export const pageTitle = (title) => {
  return ( document.title = title + " | Corner Of Art | Animation & Media Production");
}